import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-latymer',
    templateUrl: './latymer.component.html',
    styleUrls: ['./latymer.component.css'],
    standalone: false
})
export class LatymerComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
